import { computed } from '@vue/composition-api';
import { AccountState, UserRoleState } from '@/generated-types/graphql.types';
export default function useUserRoles() {
    const user = computed(() => globalThis.$store.getters['$_app/user']);
    return computed(() => ({
        [UserRoleState.Vendor]: user.value?.account_state === AccountState.Vendor,
        [UserRoleState.Booker]: user.value?.account_state === AccountState.Booker
    }));
}
